import React, { useContext, useMemo } from "react";
import { CommandBarButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { OrderRequestListingContext } from "../context/OrderRequestListingContext";
import { OrderRequestListingItem } from "../OrderRequestListingItem";

export const PinOrderRequestsButton: React.VFC = () => {
    const { selectedItems, togglePinnedOrderRequest } = useContext(OrderRequestListingContext);
    const allArePinned = useMemo(() => selectedItems.every((item) => item.isPinned), [selectedItems]);

    const handlePinOrders = () => {
        if (allArePinned) {
            pinSelectedOrders(selectedItems);
        } else {
            const unpinnedItems = selectedItems.filter((item) => !item.isPinned);
            pinSelectedOrders(unpinnedItems);
        }
    };

    const pinSelectedOrders = (orders: OrderRequestListingItem[]) => {
        orders.forEach((item) => togglePinnedOrderRequest(item.id));
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdReadWrite]}>
            <CommandBarButton
                text={allArePinned ? "Unpin" : "Pin"}
                icon="Pinned"
                disabled={!selectedItems.length}
                onClick={handlePinOrders}
            />
        </AuthorizationWrapper>
    );
};
